import {
    SYSTEM_SUBMIT_COMPANYTYPE_BEGIN,
    SYSTEM_SUBMIT_COMPANYTYPE_SUCCESS,
    SYSTEM_SUBMIT_COMPANYTYPE_FAILURE,
    SYSTEM_SUBMIT_COMPANYTYPE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitCompanyType(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_SUBMIT_COMPANYTYPE_BEGIN,
      });
  
      let apiurl = '/api/b/companyType/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/companyType/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEM_SUBMIT_COMPANYTYPE_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_SUBMIT_COMPANYTYPE_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitCompanyTypeError() {
    return {
      type: SYSTEM_SUBMIT_COMPANYTYPE_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_SUBMIT_COMPANYTYPE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitCompanyTypePending: true,
          submitCompanyTypeError: null,
        };
  
      case SYSTEM_SUBMIT_COMPANYTYPE_SUCCESS:
        // The request is success
        return {
          ...state,
          submitCompanyTypePending: false,
          submitCompanyTypeError: null,
        };
  
      case SYSTEM_SUBMIT_COMPANYTYPE_FAILURE:
        // The request is failed
        return {
          ...state,
          submitCompanyTypePending: false,
          submitCompanyTypeError: action.data.error,
        };
  
      case SYSTEM_SUBMIT_COMPANYTYPE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitCompanyTypeError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/system/redux/submitCompanyType.js